export enum OrderConfirmationTracingMessages {
  capability = 'Order Confirmation',
  pageLoadEvent = 'Order Confirmation',
  downloadOrder = 'Download Order Confirmation',
}
